(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.reactiveimageblock = window.oneadvanced.reactiveimageblock || {};
    window.oneadvanced.reactiveimageblock.init = function () {
        //console.log("initialising reactiveimageblock...");
        var reactiveImageBlock = document.querySelectorAll('[data-rib-block-id]');

        if (reactiveImageBlock.length) {
            for (var rib = 0; rib < reactiveImageBlock.length; rib++) {
                ribHandler(reactiveImageBlock[rib].getAttribute('data-rib-block-id'));
            }
        }
        function ribHandler(BlockId) {
            'use strict';
            var $reactiveImage_slider_init = false;
            var $reactiveImage_slider = $('[data-rib-block-id="' + BlockId + '"]');

            $(window).on('changed.zf.mediaquery load', function (event, newSize, oldSize) {
                if (!newSize) {
                    newSize = Foundation.MediaQuery.current;
                }

                if (newSize == "small") {
                    if ($reactiveImage_slider_init) {
                        $reactiveImage_slider.slick('unslick');
                    }

                    $reactiveImage_slider.slick({
                        dots: true,
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        mobileFirst: true
                    });
                    //console.log('slick initialized');

                    // Slick's internal lazyloading isn't compatible with our implementation
                    // so use our mutation observer to watch slick for creating clones
                    // that will internally add the cloned images to our observer

                    //defensive check for window.oneadvanced.observer.mutation_observer
                    if (window.oneadvanced.observer.hasLoaded) {
                        // Select the node that will be observed for mutations
                        var targetNode = document.querySelector('[data-rib-block-id="' + BlockId + '"]');

                        // Start observing the target node for configured mutations
                        window.oneadvanced.observer.mutation_observer.observe(targetNode,
                            window.oneadvanced.observer.mutation_observer_config);
                    } else {
                        //console.log("window.oneadvanced.observers has not been loaded. Unable to watch for Mutations.");
                    }
                    $reactiveImage_slider_init = true;
                } else {
                    if ($reactiveImage_slider_init) {
                        $reactiveImage_slider.slick('unslick');
                        $reactiveImage_slider_init = false;
                    }
                }
            });
        }
    };
    window.oneadvanced.reactiveimageblock.hasLoaded = true;

})();